import styled from 'styled-components';

export const StyledFormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  &.full-width {
    @media (min-width: 768px) {
      grid-column: span 2;
    }

    @media (min-width: 1024px) {
      grid-column: span 3;
    }
  }
`;
